// extracted by mini-css-extract-plugin
module.exports = {"artwork":"TrackArtwork_artwork__o0wTK","image":"TrackArtwork_image__w3aPn"};